module.exports = __webpack_public_path__ + "user/img/logo.de0ec56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1